import buyNowAuctionJSON from './BuyNowAuction.json';

const contract = require('@truffle/contract');

export default contract({
  abi: buyNowAuctionJSON.abi,
});
